import React, { FunctionComponent } from 'react'
import { IButtonProps } from './Button-types'
import { buttonStyles } from './Button-styles'
import { cn } from 'ethcss'
import Icon from '../../blocks.simple/icon/icon'
import { palette } from '../../theme'

export const Button: FunctionComponent<IButtonProps> = ({
    children,
    size,
    disabled,
    onClick,
    className,
    mod,
    icon,
    title,
}) => {
    const sizeStyle = size ? size : 's'
    const isIconOnly = Boolean(icon) && React.Children.count(children) === 0
    const iconPositionClass = icon && icon.position && !isIconOnly ? buttonStyles['icon-' + icon.position] : undefined

    return (
        <button
            type="button"
            title={title}
            aria-label={isIconOnly ? title : undefined}
            className={cn(
                buttonStyles.button,
                buttonStyles[mod ? mod : 'default'],
                buttonStyles[`size_${sizeStyle}`],
                isIconOnly && buttonStyles.iconOnly,
                isIconOnly && buttonStyles[`iconOnly_${sizeStyle}`],
                icon && icon.position === 'right' && !isIconOnly ? buttonStyles.iconRight : '',
                className
            )}
            disabled={disabled}
            onClick={onClick}
        >
            {icon && (
                <div className={cn(buttonStyles.icon, iconPositionClass)}>
                    <Icon
                        type={icon.type}
                        size={icon.size || 14}
                        color={icon.color ? icon.color : palette.neutral.main}
                    />
                </div>
            )}
            {children}
        </button>
    )
}
